import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from './http-utils.service';
import { environment } from 'src/environments/environment';
import { catchError, map, mergeMap } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { Me, MeTable } from '../../models/me';

@Injectable({
    providedIn: 'root',
})

export class MeService{
    private _url: string = `${environment.baseAPI}/me`;

    constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService){}

    GETMe(){
        try {
            return this._httpUtils.getHTTPHeadersAsyncMe().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}`, { headers: httpHeaders }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: MeTable = jsonConvert.deserializeObject(res, MeTable);
                            if (response.success) {
                                localStorage.setItem('tenant', response.data.tenants[0].name);
                            	return response;
                            } else {
                            	this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }
}
